var _defs, _g, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoMotorbikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#1d1e1c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.19,138.61l14.4,21.9c5.5,8.3,3.1,19.5-5.2,24.9s-19.5,3.1-24.9-5.2l-14.3-21.8c-6.6,16.3,1.2,34.8,17.5,41.4s34.8-1.2,41.4-17.5-1.2-34.8-17.5-41.4c-3.7-1.4-7.6-2.2-11.4-2.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.09,172.11h-35.1l-14.8,14h49.9c3.9,0,7-3.1,7-7s-3.1-7-7-7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M144.98,86.06l10.41-9.68-12.91-19.87c-1.3-2-3.5-3.2-5.9-3.2h-25.7v14h21.9l12.2,18.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.19,138.71c15.3-15.6,39.7-18,57.8-5.5,.8,.5,1.7,.9,2.6,1.1,.4,.1,.9,.1,1.4,.1h6.98l15.06-14h-20.04c-22.7-14.5-52.3-11.7-72,6.7l7.8,11,.4,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.39,79.91c-.33-.03-.67-.05-1-.07l-14.65,13.62c2.6-.11,5.32-.13,8.15-.05v14.8h-24.02l-11.52,10.71s.03,.06,.05,.09l19.2,29.3,8.1,12.3,8.9,13.6c2,3.3,6.4,4.3,9.6,2.3,3.3-2,4.3-6.4,2.3-9.6-.1-.1-.1-.2-.2-.3l-9-13.7-8-12.3-12.1-18.4h23.6c3.9,0,7-3.1,7-7v-28.3c0-3.7-2.8-6.7-6.4-7Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42.4,181.41c-2.44-3.05-3.91-6.9-3.91-11.09,0-9.8,8-17.8,17.8-17.8,4.66,0,8.89,1.82,12.07,4.77l10.22-9.5c-5.74-5.67-13.61-9.17-22.29-9.17-17.5,0-31.8,14.2-31.8,31.8,0,7.87,2.85,15.06,7.57,20.61l10.35-9.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.19,146.61h-21.64l-15.06,14h36.7c3.9,0,7-3.1,7-7s-3.1-7-7-7Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: -20.86,
    y: 119.17,
    width: 298.01,
    height: 17.2,
    transform: "translate(-52.7 121.42) rotate(-42.9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMotorbikeIcon);
export default __webpack_public_path__ + "static/media/NoMotorbikeIcon.56437bcc01a9080085af98f2abbac901.svg";
export { ForwardRef as ReactComponent };